import { combineReducers } from 'redux';
import todoReducer from './todoReducer';

export default combineReducers({
  todoReducer,
});



// WEBPACK FOOTER //
// ./src/dataControl/reducers/rootReducer.js